import {
    CHECK_TERMS_CONDITIONS,
    UNCHECK_TERMS_CONDITIONS
  } from '../../GlobalStateContainer'
  

  export function checkTermsAndConditions() {
    return {type: CHECK_TERMS_CONDITIONS}
  }
  
  export function unCheckTermsAndConditions() {
    return {type: UNCHECK_TERMS_CONDITIONS}
  }